import React from "react";
import styled from "styled-components";

import ItemBubbleColumn from "./ItemBubbleColumn";

const Styled = styled.div`
  display: flex;
`;

const Grid = styled.div`
  display: flex;
  border: solid 1px #ddd;
  background-color: #fff;
  width: auto;
`;

interface Props {
  columns: number;
  value: string;
  onChange: (value: string) => void;
}

const ItemBubble: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const columns: React.ReactNode[] = [];
  for (let index = 0; index < props.columns; index++) {
    columns.push(
      <ItemBubbleColumn
        value={props.value[index]}
        onChange={(value) => {
          const newValue =
            props.value.substr(0, index) +
            value +
            props.value.substr(index + 1);
          props.onChange(newValue);
        }}
      />,
    );
  }

  return (
    <Styled>
      <Grid>{columns}</Grid>
    </Styled>
  );
};

export default ItemBubble;
